import { useMemo } from 'react';
import { StayOverTypeEnum } from 'api/model';
import useTranslations from 'contexts/basicData/useTranslations';

// Get all available assignment type options (numbers only)
export const allOptions: StayOverTypeEnum[] = Object.values(
  StayOverTypeEnum
).filter((s) => typeof s === 'number') as StayOverTypeEnum[];

const useStayOverTypeOptions = (): {
  type: StayOverTypeEnum | undefined;
  label: string;
}[] => {
  const { stayOverTypes } = useTranslations();

  const options = useMemo(() => {
    const result: {
      type: StayOverTypeEnum | undefined;
      label: string;
    }[] = allOptions.map((v) => ({
      type: v,
      label: stayOverTypes[Number(v)] ?? '',
    }));

    // splice in the "ingen övernattning" undefined option
    const ingenOvernatting = {
      type: undefined,
      label: 'NEJ',
    };
    result.splice(0, 0, ingenOvernatting);
    return result;
  }, [stayOverTypes]);

  return options;
};

export default useStayOverTypeOptions;
